var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"headerbox"},[_c('img',{attrs:{"src":require("../assets/herder.png"),"alt":"","width":"370"},on:{"click":_vm.Botell}})])])}
var staticRenderFns = []

export { render, staticRenderFns }